import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NonMembersRoutingModule } from './non-members-routing.module';
import { NonMembersComponent } from './non-members.component';
import { EffectsModule } from '@ngrx/effects';
import { NonMemberModuleEffects } from '@app/areas/non-members/store';
import { NonMembersApiService } from '@app/areas/non-members/services';
import { NonMemberModuleRouteResolver, NonMemberRouteResolver } from '@app/areas/non-members/resolvers';

@NgModule({
  imports: [
    CommonModule,
    NonMembersRoutingModule,
    NonMembersComponent,
    EffectsModule.forFeature([NonMemberModuleEffects]),
  ],
  providers: [NonMembersApiService, NonMemberModuleRouteResolver, NonMemberRouteResolver],
})
export class NonMembersModule {}
